module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b58Bb"))).then(() => parcelRequire('dJXJK'));